import React from 'react';
//
import { Button } from '../../../components/buttons/buttons';
import { Modal } from '../../../components/modals/antd-modals';
import { BasicFormWrapper } from '../../styled';

const DeleteImportedCar = ({ visible, onCancel, car, handleDelete }) => {
  const handleSubmit = () => {
    handleDelete(car?._id);
    onCancel();
  };

  if (!car) return <></>;

  return (
    <Modal
      type="primary"
      title="Delete Car"
      visible={visible}
      footer={[
        <div key="1" className="car-modal-footer">
          <Button
            size="default"
            style={{ backgroundColor: '#155BDC', color: '#fff' }}
            key="submit"
            onClick={handleSubmit}
          >
            Delete Car
          </Button>
          <Button size="default" type="white" key="back" outlined onClick={onCancel}>
            Cancel
          </Button>
        </div>,
      ]}
      onCancel={onCancel}
    >
      <div className="car-modal">
        <BasicFormWrapper>
          <p>Delete car &quot;{car?.meta?.name}&quot;</p>
          <i>It will delete all the datas related to this car</i>
        </BasicFormWrapper>
      </div>
    </Modal>
  );
};

export default DeleteImportedCar;
